import styles from "./styles.module.scss";
import { DetailedHTMLProps, ImgHTMLAttributes, useState } from "react";
import jpeg from "../../assets/jpegFile.png";
import jpg from "../../assets/jpgFile.png";
import pdf from "../../assets/pdf.png";
import docx from "../../assets/docx.png";
import xlsx from "../../assets/xlsx.png";
import { FaDownload } from "react-icons/fa";
import { MdOutlineDownloading } from "react-icons/md";
import { toast } from "react-toastify";

type Props = DetailedHTMLProps<
  ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  url: string;
};

export function getFileType(filename: string): string | null {
  if (!filename || filename.indexOf(".") === -1) {
    return null;
  }
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === 0 || lastDotIndex === filename.length - 1) {
    return null;
  }
  const fileExtension: string = filename.substring(lastDotIndex + 1);
  return fileExtension;
}

function fileImg(filename: string): any {
  const fileType = getFileType(filename);
  switch (fileType) {
    case "jpeg":
      return jpeg;
    case "jpg":
      return jpg;
    case "docx":
      return docx;
    case "xlsx":
      return xlsx;
    case "pdf":
      return pdf;
    default:
      return pdf;
  }
}

export default function FileExtImage({ src, alt, url, ...rest }: Props) {
  const [downloading, setDownloading] = useState(false);

  const handleForceDownload = async (rawFilename: string, rawUrl: string) => {
    setDownloading(true);

    // 1️⃣ encode the URL so fetch and the browser see it correctly
    const safeUrl = encodeURI(rawUrl);

    try {
      const response = await fetch(safeUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 2️⃣ pull down the blob
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      // 3️⃣ decode the filename so "%20" becomes spaces
      const decodedName = decodeURIComponent(rawFilename);

      // 4️⃣ create & click the temporary link
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = decodedName; // "CERTIFICATE - A.G.H INVESTMENTS NIG LTD-…pdf"
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 5️⃣ clean up
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed -> ", error);
      toast.error("Something went wrong! Try again later");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className={styles.imgContainer}>
      <img
        src={fileImg(src as string)}
        alt={alt}
        {...rest}
        className={styles.img}
      />
      {downloading ? (
        <MdOutlineDownloading
          color="#9747ff"
          size={20}
          style={{ marginLeft: "1rem" }}
        />
      ) : (
        // <a href={url} target="_blank" rel="noreferrer" download>
        <FaDownload
          color="#9747ff"
          size={16}
          className={styles.download}
          onClick={() => handleForceDownload(src as string, url)}
        />
        // </a>
      )}
    </div>
  );
}
